<app-section #parentSection
             [formConfig]="formConfig"
             [sectionRef]="section"
             [key]="key"
             [formGroup]="formGroup">

    <ng-template #section>

        <div fxLayout="column" fxFlexAlign="center center">
            <div fxFlexAlign="center">
                <div class="section__title" fxFlexAlign="center">
                    <h1 class="container__title">
                        {{'ERROR_NOTIFY_SECTION.header' | translate}}
                    </h1>
                </div>

               <div>
                   <img style="max-width: 100%" [src]="assetsService.informationDialogImageSrc">
               </div>
            </div>

            <div class="notify" fxFlexAlign="center">
                <div class="notify__description" [innerHTML]="notificationState.message | safeHtml"></div>
            </div>

            <div class="wizard__next-container" fxFlexAlign="center">
                <!--<div class="button__container">-->
                    <!--<button class="btn btn&#45;&#45;secondary btn&#45;&#45;big btn&#45;&#45;error-container"-->
                            <!--(click)="backToOffer()">-->
                        <!--Wróć do oferty-->
                    <!--</button>-->
                <!--</div>-->

                <div class="button__container">
                    <button class="btn btn--secondary-inverted btn--big btn--error-container"
                            [ngClass]="{'btn--anchor': anchorButton}"
                            (click)="backToLandingPage()">
                        <ng-container *ngIf="!anchorButton; else anchorBtn">
                            {{ 'ERROR_NOTIFY_SECTION.backToHomePage' | translate }}
                        </ng-container>
                        <ng-template #anchorBtn>
                            <a [href]="redirectUrl | safeUrl" target="_blank">
                                {{ 'ERROR_NOTIFY_SECTION.backToHomePage' | translate }}
                            </a>
                        </ng-template>
                    </button>
                </div>
            </div>
        </div>

    </ng-template>
</app-section>
